<template lang="pug">
  el-submenu(:index='pgRoute',)
    div(slot='title', :class='isMenuActive(pgRoute)', @click='handleSelectMenu')
      font-awesome-icon(:icon='["fal", pgIcon]').el-icon-for-fa.fs-14
      span
        slot
          // default slot
    el-menu-item(
      v-for='(teamItem, index) in this.myTeamList',
      :key='index',
      :index='`${pgRoute}/${teamItem.id}`',
    ).d-flex.align-items-center
      font-awesome-icon(:icon='["fal", teamItem.icon]').el-icon-for-fa.fs-14
      span(slot='title').text-truncate {{ teamItem.groupName }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppSubMenuWithTeamsView',
  props: {
    pgRoute: {
      type: String,
      default: '',
    },
    pgIcon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localTeamList: [],
    };
  },
  computed: {
    ...mapGetters('users', ['me', 'userCardInfo', 'myTeamList', 'userAccAccess']),
    ...mapGetters('groups', ['groupList']),
  },

  methods: {
    ...mapActions('users', ['getMe', 'getUserInfoCard']),
    ...mapActions('groups', ['getGroupList']),
    isMenuActive(route) {
      if (this.$route.path === route) return 'is-active';
      return '';
    },
    handleSelectMenu() {
      // available perms: key, keyPath
      if (this.$route.path === this.pgRoute) return;
      this.$router.push(this.pgRoute);
    },
  },
};
</script>
